<template>
  <div class="page-box">
    <div class="page-content">
      <div class="list-box">
        <div class="banner-title-box">
          <div class="banner-title">待服务</div>
        </div>
        <div
          class="list-main"
          v-for="(item, index) in toBeCompletedList"
          :key="index"
          @click="goOrderDetail(item)"
        >
          <div class="list-item">
            <van-image
              :src="item.coverUrl"
              fit="cover"
              width="120"
              height="100"
            />
            <div class="item-info">
              <div class="item-title-box">
                <div class="item-title">{{ item.parentName }}</div>
                <div class="item-remark">{{ item.statusName }}</div>
              </div>
              <div class="item-desc">{{ item.monthDay }}</div>
              <div class="item-desc">
                {{
                  item.additionalSpuName !== ""
                    ? item.additionalSpuName
                    : item.name
                }}
              </div>

              <div class="item-price-box">
                <div class="item-price">
                  <template>
                    <span class="unit1">¥</span>
                    {{ item.price === 0 ? "免费" : item.price }}
                  </template>
                </div>
              </div>
            </div>
          </div>

          <div class="operate-box">
            <!--<div
              class="operate-btn"
              @click.stop="showQrCode(item)"
              v-if="item.status !== 45"
            >
              出示服务码
            </div>-->
            <div
              class="operate-btn appointment-btn"
              @click.stop="handleCancel(item)"
            >
              取消
            </div>
          </div>
        </div>
        <van-empty
          class="custom-image"
          v-if="!toBeCompletedList.length"
          image="https://img.yzcdn.cn/vant/custom-empty-image.png"
          description="暂无待服务"
        />
      </div>

      <div class="list-box">
        <div class="banner-title-box">
          <div class="banner-title">历史预约</div>
        </div>
        <div
          class="list-main"
          v-for="(item, index) in completedList"
          :key="index"
          @click="goOrderDetail(item)"
        >
          <div
            class="list-item"
            :class="{
              'border-bottom-none': completedList.length - 1 === index,
            }"
          >
            <van-image
              :src="item.coverUrl"
              fit="cover"
              width="120"
              height="100"
            />
            <div class="item-info">
              <div class="item-title-box">
                <div class="item-title">{{ item.parentName }}</div>
                <div
                  class="item-remark"
                  :class="[
                    item.statusName === '已取消'
                      ? 'item-remark-cancel'
                      : 'item-remark-finish',
                  ]"
                >
                  {{ item.statusName }}
                </div>
              </div>
              <div class="item-desc">{{ item.monthDay }}</div>
              <div class="item-desc">{{ item.name }}</div>

              <div class="item-price-box">
                <div class="item-price">
                  <template >
                    <span class="unit1">¥</span>
                    {{ item.price === 0 ? "免费" : item.price }}
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <van-empty
          class="custom-image"
          v-if="!completedList.length"
          image="https://img.yzcdn.cn/vant/custom-empty-image.png"
          description="暂无历史预约"
        />
      </div>
    </div>

    <div class="dialog-box" v-show="innerVisible">
      <div id="qrcode" ref="qrcode"></div>
    </div>
    <div class="dialog-bg" v-show="innerVisible" @click="hideDialog"></div>
    <van-dialog
      v-model="show"
      :closeOnClickOverlay="true"
      confirmButtonColor="#ffffff"
      confirmButtonText="提交"
      title="取消原因"
      :before-close="onBeforeClose"
      @confirm="handleConfirm"
    >
      <van-form ref="myform">
        <van-field
          v-model="closeReason"
          ref="fieldRef"
          type="textarea"
          rows="4"
          maxlength="50"
          show-word-limit
          autosize
          name="closeReason"
          :rules="[{ required: true, message: '取消原因不能为空' }]"
          placeholder="请填写取消原因，有助于商家更好的处理问题。"
        />
      </van-form>
    </van-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import {
  makeAnAppointmentOrder,
  makeAnAppointmentCancel,
} from "@/api/index/index";
export default {
  name: "myMakeAnAppointment",
  data() {
    return {
      closeReason: "",
      toBeCompletedList: [],
      completedList: [],
      innerVisible: false,
      show: false,
      currentItem: {},
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    onBeforeClose(action, done) {
      if (action === "confirm") {
        return done(false);
      } else {
        // 重置表单校验
        this.$refs["myform"].resetValidation("closeReason");
        this.closeReason = "";
        return done();
      }
    },
    handleConfirm() {
      this.$refs["myform"]
        .validate()
        .then(async () => {
          let res = await makeAnAppointmentCancel({
            primaryKey: this.currentItem.primaryKey,
            closeType: 4, // 客户取消是4
            closeReason: this.closeReason,
          });
          if (res.success) {
            this.currentItem = {};
            this.$toast.success("取消成功");
            this.show = false;
            setTimeout(() => {
              this.getList();
            }, 1000);
          }
        })
        .catch(() => {});
    },
    goOrderDetail(item) {
      this.$router.push({
        name: "order-details",
        query: {
          orderKey: item.primaryKey,
        },
      });
    },
    async getList() {
      let res = await makeAnAppointmentOrder();
      this.toBeCompletedList = res.data.toBeCompleted
        ? res.data.toBeCompleted.rows
        : [];
      this.completedList = res.data.completed ? res.data.completed.rows : [];
    },
    handleCancel(item) {
      this.closeReason = "";
      this.currentItem = item;
      this.show = true;
    },
    // 展示二维码
    showQrCode(item) {
      this.innerVisible = true;
      this.$nextTick(() => {
        this.crateQrcode(
          `/service/orderDetails?orderKey=${item.primaryKey}&qrCode=true`
        );
      });
    },
    // 生成二维码
    crateQrcode(qrcode) {
      this.qr = new QRCode("qrcode", {
        width: 150,
        height: 150, // 高度
        text: qrcode, // 二维码内容
        // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f'
        // foreground: '#ff0'
      });
    },
    // 关闭弹框,清除已经生成的二维码
    hideDialog() {
      this.$refs.qrcode.innerHTML = "";
      this.innerVisible = false;
      setTimeout(() => {
        this.getList();
      }, 1500);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .van-dialog {
  .van-dialog__header {
    padding: 20px 16px;
    color: #333333;
    font-weight: bold;
  }
  .van-dialog__content {
    /deep/ .van-field--error .van-field__control,
    .van-field--error .van-field__control::placeholder {
      color: #969799 !important;
    }
    .van-cell {
      padding: 0px 16px;
      .van-cell__value {
        .van-field__body {
          .van-field__control {
            background: #eeeeee;
            padding: 10px 0px 0px 10px;
            color: #666666;
            border-radius: 15px;
          }
        }
        .van-field__word-limit {
          position: absolute;
          bottom: 24px;
          right: 10px;
        }
      }
    }
  }
  .van-dialog__footer {
    margin: 20px 16px;
    .van-button {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #16aa77;
      border-radius: 20px;
      height: 40px;
      line-height: 40px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 500;
      .van-button__text {
        color: #ffffff;
        height: 40px;
        line-height: 40px;
      }
    }
  }
  .van-dialog__footer::after {
    border: initial;
  }
}
.page-box {
  background: #eeeeee;

  .page-content {
    padding: 0 12px 10px;
  }

  .custom-image {
    /deep/ .van-empty__image {
      width: 90px;
      height: 90px;

      img {
        width: 90px;
        height: 90px;
      }
    }
  }
}

.list-box {
  margin-top: 10px;
  border-radius: 5px;
  background: #fff;
  .banner-title-box {
    padding: 15px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #d8d8d8;

    .banner-title {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #333333;
      margin-right: 10px;
    }
  }
  .list-main {
    padding: 0 10px;
    .list-item {
      padding: 15px 0;
      border-bottom: 1px solid #d8d8d8;
      display: flex;
      align-items: center;

      .van-image {
        border-radius: 5px;
        overflow: hidden;
      }
      .item-info {
        height: 100px;
        margin-left: 15px;
        flex: 1;
        display: flex;
        flex-direction: column;
        .item-title-box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .item-title {
            font-size: 13px;
            font-family: PingFang SC;
            font-weight: 600;
            color: #333333;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            flex: 1;
          }

          .item-remark {
            margin-left: 10px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #fa6400;
          }

          .item-remark-cancel {
            color: #dadada;
          }
          .item-remark-finish {
            color: #666666;
          }
        }

        .item-desc {
          margin-top: 9px;
          height: 12px;
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #666666;
          display: flex;
          align-items: center;
          .time-icon {
            width: 13px;
            height: 13px;
            margin-right: 3px;
          }
        }

        .item-price-box {
          margin-top: 9px;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .item-price {
            display: flex;
            align-items: center;
            color: #333;
            font-size: 16px;
            font-family: PingFangSC-Regular;
            font-weight: 600;
            .unit1 {
              font-size: 12px;
              font-family: PingFangSC-Semibold;
            }
          }
        }
      }
    }
    .border-bottom-none {
      border-bottom: none;
    }
    .operate-box {
      padding: 15px 0;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .operate-btn {
        margin-left: 10px;
        padding: 0 20px;
        height: 27px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #16aa77;
        border-radius: 14px;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }

      .appointment-btn {
        background: #c9c9c9;
      }
    }
  }
}
.dialog-box {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  background: #fff;
  padding: 10px;
}
.dialog-bg {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
}
</style>
